<!-- 弹窗公用组件 -->
<template id="s-popup">
  <article class="s-popup" v-show="isShow" @click="wrapperClose($event)">
    <!-- <transition> -->
      <div class="s-popup-wrapper">
        <section class="s-popup-header clearfix" v-show="hasHeader">
          <h4 class="fl">{{ title }}</h4>
          <a href="javascript:;" @click="closePopup" class="fr s-popup-close" v-show="hasClose">
            <span><img src="../images/common/close.png" alt=""></span>
          </a>
        </section>
        <section class="s-popup-body" v-show="hasBody">
          <slot name="popup-body"></slot>
        </section>
        <section class="s-popup-footer" v-show="hasFooter">
          <slot name="popup-footer"></slot>
        </section>
      </div>
    <!-- </transition> -->
  </article>
</template>

<script>
  export default {
    /*
     ** 参数说明
     ** title: 弹窗标题 String
     ** show: 是否显示弹窗  Boolean
     ** has_header: 是否有头部  Boolean
     ** has_body: 是否有内容块  Boolean
     ** has_footer: 是否有底部  Boolean
     ** quick_close: 是否可以点击遮罩关闭弹窗  Boolean
     ** has_close: 是否有关闭按钮  Boolean
     */
    props: ['title', 'show', 'has_header', 'has_body', 'has_footer', 'quick_close', 'has_close'],
    computed: {
      isShow() {
        return this.show
      },
      hasHeader() {
        return this.has_header === false ? false : true;
      },
      hasBody() {
        return this.has_body === false ? false : true;
      },
      hasFooter() {
        return this.has_footer === false ? false : true;
      },
      quickClose() {
        return this.quick_close === false ? false : true;
      },
      hasClose() {
        return this.has_close === false ? false : true;
      }
    },
    watch: {
      isShow (val) {
        if (val) {
          this.$emit('on-shown')
        }
      }
    },
    methods: {
      /*
       ** 触发关闭弹窗事件，实现由父组件定义
       */
      closePopup() {
        this.$emit('close');
      },
      /*
       ** 点击遮罩关闭弹窗
       */
      wrapperClose(e) {
        if(this.quickClose && e.target === e.currentTarget){
          this.closePopup();
        }
      }
    }
  }
</script>

<style media="screen" lang="scss" scoped>
  .s-popup{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    &-wrapper{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      min-width: 435px;
      min-height: 250px;
      padding: 20px;
      background-color: #fff;
      transition: all linear .5s;
      border-radius: 4px;
    }
    &-header{
      font-size: 16px;
      color: #090b1a;
    }
    &-close{
      padding: 0 5px;
      color: #231f20;
    }
  }
</style>



// WEBPACK FOOTER //
// popup.vue?069018a8